<template>
    <div class="menu" :class="{ loader: loading }">
        <h2><slot name="title"></slot></h2>
        <div class="content" v-if="this.$props.isDelivery === false">
            
                <div class="menu-item" v-for="(meal, index) in meals" :key="index">
                  
                    <div class="meal-image" v-if="meal.image">
                        <img :src="meal.image.path">
                    </div>
                    <div class="meal-wrapper">
                    <div class="meal-top">
                        <h4>{{ meal.name }}</h4>
                        <div class="price-wrapper">
                            <div class="price price-small" v-if="meal.price_small_delivery !== null">{{ meal.price_small }}€</div>
                            <div class="price price-large" :class="{ removebefore: meal.removeBefore }">{{ meal.price }}€</div>  
                        </div>             
                    </div>
                    <span class="dotted-line"></span>
                    <div class="meal-bottom">
                        <p class="description">{{ meal.description }}</p>
                    </div>
                    </div>
                </div>

    </div>
    <div class="content" v-else-if="this.$props.isBrunch === true">
            
                <div class="menu-item" v-for="(meal, index) in allBrunches" :key="index">
                    <div class="meal-image" v-if="meal.image">
                        <img :src="meal.image.path">
                    </div>
                    <div class="meal-wrapper">
                    <div class="meal-top">
                        <h4>{{ meal.name }}</h4>
                        <div class="price-wrapper">
                            <div class="price price-brunch" v-if="meal.price_brunch !== null">{{ meal.price_brunch }}€</div>
                            <div class="price price-brunch-delivery">9.80€</div>  
                        </div>             
                    </div>
                    <span class="dotted-line"></span>
                    <div class="meal-bottom">
                        <p class="description">{{ meal.description }}</p> 
                    </div>
                    </div>
                </div>

    </div>
     <div class="content" v-else>

                <div class="menu-item" v-for="(meal, index) in meals" :key="index">
                    <div class="menu-item-inner"  v-if="meal.price_delivery !== null">
                    <div class="meal-image" v-if="meal.image">
                        <img :src="meal.image.path">
                    </div>
                    <div class="meal-wrapper">
                    <div class="meal-top">
                        <h4>{{ meal.name }}</h4>
                        <div class="price-wrapper">

                            <div class="price price-small" v-if="meal.price_small_delivery !== null">{{ meal.price_small_delivery }}€</div>
                            <div class="price price-large" :class="{ removebefore: meal.removeBefore }">{{ meal.price_delivery }}€</div>  
                        </div>             
                    </div>
                    <span class="dotted-line"></span>
                    <div class="meal-bottom">
                        <p class="description">{{ meal.description }}</p>
                    </div>
                    </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<style lang="scss" scoped>
@import 'menu-section.scss';

.meal-wrapper {
    display:flex;
    flex-direction: column;
    width: 100%;
    margin-left: 1em;

    @include screen('mobtab') {
            margin-left:.5em;
        }
}

.meal-image {


    img {
    width:100px;
    height:100px;
    object-fit:cover;
    border-radius:100px;

    @include screen('mobile') {
            width:60px;
            height:60px;
        }
    }
}

.menu-item-inner {
    display: flex;
    align-items: center;
    width:100%;
}

.menu-item {
    display:flex;
    flex-direction: row;
    align-items: center;
}

.meal-bottom {
    width: 100%;
    text-align: left;

    
}

.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2em;
  height: 2em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.loader {
  color: #e1251b;
  font-size: 6px;
  margin: 80px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 0;
}
.loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

</style>

<script>
export default {
    props: ['meals', 'isDelivery', 'isBrunch'],
    data: () => ({
        loading: true
    }),
    watch: {
        meals: function() {
            if(this.$props.meals.length > 0) {
                this.loading = false;
            }
            
            for(let i = 0; i < this.$props.meals.length; i++) {
                if(this.$props.meals[i].price_small === null) {
                    this.$props.meals[i].removeBefore = true;
                }

            }
        }
    },
    computed: {
      allBrunches() {
      return this.meals.filter(meal => meal.brunch === 1 || meal.types[0].id === 14);
    },

    }
	
};
</script>